import { api } from '@src/api/api'
import { CouponType } from '@src/types/coupons'

type GetAllType = {
  next: boolean
  total: number
  coupons: CouponType[]
}

export const couponsApi = {
  getAll(page: number) {
    return api.get<GetAllType>('/v1/coupons/all', { page })
  },
}
